import './Pagination.css';
import useLang from '../../hooks/use-lang/useLang.js';

function Pagination({ page, totalPages, onChange }) {
  const { t } = useLang();
  if (totalPages <= 1) return null;

  return (
    <div className="pagination">
      <button
        className="pagination__btn"
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        aria-label={t('common.prevPage', 'Previous page')}
      >
        ‹
      </button>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
        <button
          key={n}
          type="button"
          className={n === page ? 'pagination__btn pagination__btn--active' : 'pagination__btn'}
          onClick={() => onChange(n)}
        >
          {n}
        </button>
      ))}
      <button
        className="pagination__btn"
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        aria-label={t('common.nextPage', 'Next page')}
      >
        ›
      </button>
    </div>
  );
}

export default Pagination;
